import { create } from 'zustand';

// Área activa (slug). Determina qué proyección de fuentes aplica el back en
// TODAS las requests de products. `null` = sin área elegida — el back sigue
// aceptando el `default` explícito del body (comportamiento actual).
//
// Persistente por usuario en localStorage para que la elección sobreviva
// reloads. Sin persistencia por rol/tenant — asume un solo usuario por
// browser (el admin panel es interno).
export interface AreaState {
  activeAreaSlug: string | null;
  setActiveArea: (slug: string | null) => void;
}

const STORAGE_KEY = 'cef:active-area';

function readStored(): string | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

function writeStored(slug: string | null): void {
  try {
    if (slug === null) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // localStorage bloqueado; el store sigue en memoria.
  }
}

const initial: string | null =
  typeof window === 'undefined' ? null : readStored();

export const useAreaStore = create<AreaState>((set) => ({
  activeAreaSlug: initial,
  setActiveArea: (slug) => {
    writeStored(slug);
    set({ activeAreaSlug: slug });
  },
}));
